import { render, staticRenderFns } from "./TabelaEntidades.vue?vue&type=template&id=4b31ac1f&scoped=true&"
import script from "./TabelaEntidades.vue?vue&type=script&lang=js&"
export * from "./TabelaEntidades.vue?vue&type=script&lang=js&"
import style0 from "./TabelaEntidades.vue?vue&type=style&index=0&id=4b31ac1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31ac1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDataTable,VOverlay,VProgressCircular})
